module.exports = __webpack_public_path__ + "static/media/backward.a1984b45.svg";